document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
        const relatedPostsSwiper = new Swiper('.related-posts-swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 25,
            grabCursor: true,
            navigation: {
                nextEl: '.related-posts-next',
                prevEl: '.related-posts-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    }
});